<template>
  <div id="userAll">
    <div class="classify">
      <div class="left">
        <span class="status">状态：</span>
        <span
          @click="setStatusAct(0, null)"
          :class="statusAct === 0 ? 'act' : 'statusList'"
          >全部</span
        >
        <!--        <span-->
        <!--          @click="setStatusAct(1, '已审核')"-->
        <!--          :class="statusAct === 1 ? 'act' : 'statusList'"-->
        <!--        >已审核</span-->
        <!--        >-->
        <span
          @click="setStatusAct(1, 1)"
          :class="statusAct === 1 ? 'act' : 'statusList'"
          >已发布</span
        >
        <span
          @click="setStatusAct(2, 2)"
          :class="statusAct === 2 ? 'act' : 'statusList'"
          >审核中</span
        >
        <span
          @click="setStatusAct(3, 3)"
          :class="statusAct === 3 ? 'act' : 'statusList'"
          >未通过</span
        >
        <span
          @click="setStatusAct(4, 4)"
          :class="statusAct === 4 ? 'act' : 'statusList'"
          >已下架</span
        >
        <span
          @click="setStatusAct(5, 5)"
          :class="statusAct === 5 ? 'act' : 'statusList'"
          >草稿</span
        >
      </div>
      <div class="right">
        <span class="time">时间：</span>
        <DatePicker
          :value="value2"
          format="yyyy/MM/dd"
          @on-change="handleChange"
          type="daterange"
          placement="bottom-end"
          placeholder="Select date"
          style="width: 220px"
        ></DatePicker>
        <Input
          v-model="search"
          placeholder="请输入标题进行搜索"
          class="searchinput"
        >
          <Icon @click="handleClick" type="ios-search" slot="suffix" />
        </Input>
        <input type="text" style="opacity: 0; width: 0" />
      </div>
    </div>

    <div class="list">
      <div class="box" v-for="item in list" :key="item.articleId">
        <div class="left">
          <img
            v-if="item.cover"
            v-lazy="`${$global.imgUrl}${item.cover}`"
            alt=""
          />
          <div class="msg" :style="{ marginLeft: item.cover ? '20px' : '0px' }">
            <!-- <div class="top" v-if="item.status !== 2 || item.auditStatus === 0"> -->
            <div class="top" v-if="item.status !== 2">
              <span :class="item.auditStatus | colored">{{
                item.auditStatus | type
              }}</span
              ><span></span>
              <span v-html="item.title"></span>
            </div>
            <div class="top" v-else>
              <span class="down">已下架</span><span></span>
              <span v-html="item.title"></span>
            </div>
            <div v-if="item.auditStatus === 2" class="read">
              <span class="key"
                >阅读量：<span class="value">{{ item.readPv }}</span></span
              ><span class="key"
                >收藏量：<span class="value">{{ item.collectPv }}</span></span
              ><span class="key"
                >分享量：<span class="value">{{ item.sharePv }}</span></span
              >
            </div>
            <div v-else-if="item.auditStatus === 3" class="read">
              <span class="key"
                >原因：<span class="value">{{ item.opinion }}</span></span
              >
            </div>
            <div v-else class="read"></div>
          </div>
        </div>
        <div class="right">
          <div class="time">{{ item.createTime }}</div>
          <!-- <div class="edit" v-if="item.status !== 2 || item.auditStatus === 0"> -->
          <div class="edit" v-if="item.status !== 2">
            <template v-if="item.auditStatus === 2">
              <span class="blue" @click="openDrawer(item)">详细信息</span>
              <!-- <span class="blue" @click="edit(item)">修改</span> -->
              <span class="black">修改</span>
              <span class="blue" @click="del(item)">删除</span>
            </template>
            <template v-if="item.auditStatus === 0">
              <span class="black">修改</span>
              <span class="black">删除</span>
            </template>
            <template v-if="item.auditStatus === 3">
              <span @click="edit(item)" class="blue">修改</span>
              <span class="blue" @click="del(item)">删除</span>
            </template>
            <template v-if="item.auditStatus === 1">
              <span @click="edit(item)" class="blue">修改</span>
              <span class="blue" @click="del(item)">删除</span>
            </template>
          </div>
          <div class="edit" v-else>
            <!-- <span class="blue" @click="edit(item)">修改</span> -->
            <span class="black">修改</span>
            <span class="blue" @click="del(item)">删除</span>
          </div>
        </div>
      </div>
    </div>
    <Paging
      :total="total"
      :curPage="page"
      :limit="10"
      :showPage="5"
      @changePager="handlePager"
    ></Paging>
    <Drawer :mask-closable="false" width="769" v-model="detailsShow">
      <DrawerDetail v-if="detailsShow" :articleId="drawerId" :articleType="drawerType"/>
    </Drawer>
  </div>
</template>

<script>
// import { mapState } from "vuex";
import Paging from "@/components/paging/index.vue";
import DrawerDetail from "./drawerDetail.vue";

export default {
  name: "all",
  // computed: {
  //   ...mapState(["token", "userInfo"])
  // },
  components: { Paging,DrawerDetail },
  data() {
    return {
      value2: [null, null],
      search: null,
      statusAct: 0,
      page: 1,
      total: 0,
      list: [],
      status: null,
      detailsShow: false,
      drawerId: '',
      drawerType: '',
    };
  },
  filters: {
    type: function (num) {
      if (num === 2) {
        return "已发布";
      } else if (num === 0) {
        return "审核中";
      } else if (num === 3) {
        return "未通过";
      } else if (num === 1) {
        return "草稿";
      }
    },
    colored: function (num) {
      if (num === 2) {
        return "send";
      } else if (num === 0) {
        return "ing";
      } else if (num === 3) {
        return "pass";
      } else if (num === 1) {
        return "edit";
      }
    },
  },
  created() {
    this.getList();
  },
  methods: {
    // 打开详细信息抽屉
    openDrawer(e) {
      this.detailsShow = true
      this.drawerId = e.articleId
      this.drawerType = 5
    },
    edit(e) {
      let { articleId } = e;
      this.$router.push(`/informationForm?id=${articleId}&title=资讯`);
      console.log("资讯");
    },
    del(e) {
      this.$Modal.confirm({
        title: '操作确认',
        content: `<p>是否删除<<span>${e.title}</span>>?删除后无法恢复</p>`,
        onOk: async () => {
          let obj = {
            articleId: e.articleId,
            articleType: 5,
            auditStatus: e.auditStatus,
          };
          const res = await this.$apis.userServe.delId(obj);
          if (res.resultCode === "200") {
            this.$Message.success("删除成功");
            this.getList();
          }
        },
        onCancel: () => {
          this.$Message.info('已取消删除操作');
        }
      });
    },
    async donw(e) {
      console.log(e);
      let obj = {
        articleId: e.articleId,
        articleType: 5,
      };
      console.log(obj);
      const res = await this.$apis.userServe.downId(obj);
      if (res) {
        await this.getList();
      }
    },
    handlePager(e) {
      console.log(e);

      this.page = e;
      this.getList();
    },
    handleClick() {
      this.page = 1;
      this.getList();
    },
    handleChange(value) {
      console.log(value);
      this.page = 1;
      this.getList();
    },
    setStatusAct(i, status) {
      this.statusAct = i;
      this.status = status;
      this.page = 1;
      this.getList();
    },
    async getList() {
      let obj = {
        pageNo: this.page,
        pageSize: 10,
        title: this.search,
        beginTime: this.value2[0],
        endTime: this.value2[1],
        status: this.status,
      };
      console.log(obj);
      const { data } = await this.$apis.userServe.getUserMessageMrgList(obj);
      let { total } = data;
      this.total = Number(total);
      this.list = data.list;

      // console.log(this.list,"this.list");
      console.log(data.list, "this.list");
    },
  },
};
</script>

<style lang="scss" scoped>
#userAll {
  padding-top: 30px;
  //background: yellow;
  width: 1200px;
  // height: 300px;
  .list {
    margin-top: 30px;

    .box {
      display: flex;
      justify-content: space-between;
      margin-bottom: 20px;
      padding: 20px 45px;
      width: 1200px;
      min-height: 130px;
      background: #ffffff;
      box-shadow: 0px 7px 15px 1px rgba(22, 26, 100, 0.13);

      .right {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        width: 190px;

        .time {
          font-size: 12px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #666666;
          text-align: right;
        }

        .edit {
          text-align: right;
          span {
            margin-left: 25px;
            cursor: pointer;
          }

          .blue {
            color: rgba(11, 53, 197, 1);
          }

          .black {
            color: #999999;
          }
        }
      }

      .left {
        display: flex;
        flex: 1;

        img {
          width: 122px;
          height: 122px;
        }

        .msg {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          width: 778px;
          font-size: 14px;

          .top {
            width: 100%;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;

            .edit {
              color: #ff9415;
              margin-right: 10px;
              //display: inline-block;
              //border-right: #FF9415 1px solid;
              //padding-right: 10px;
              //height: 20px;
            }

            .edit + span {
              margin-bottom: -2px;
              margin-right: 10px;
              width: 2px;
              height: 15px;
              background: #ff9415;
              display: inline-block;
            }

            .send {
              color: #10286f;
              margin-right: 10px;
              //display: inline-block;
              //border-right: #FF9415 1px solid;
              //padding-right: 10px;
              //height: 20px;
            }

            .send + span {
              margin-bottom: -2px;
              margin-right: 10px;
              width: 2px;
              height: 15px;
              background: #10286f;
              display: inline-block;
            }

            .ing {
              color: #8073d2;
              margin-right: 10px;
              //display: inline-block;
              //border-right: #FF9415 1px solid;
              //padding-right: 10px;
              //height: 20px;
            }

            .ing + span {
              margin-bottom: -2px;
              margin-right: 10px;
              width: 2px;
              height: 15px;
              background: #8073d2;
              display: inline-block;
            }

            .pass {
              color: #ff0000;
              margin-right: 10px;
              //display: inline-block;
              //border-right: #FF9415 1px solid;
              //padding-right: 10px;
              //height: 20px;
            }

            .pass + span {
              margin-bottom: -2px;
              margin-right: 10px;
              width: 2px;
              height: 15px;
              background: #ff0000;
              display: inline-block;
            }

            .down {
              color: #dc727c;
              margin-right: 10px;
              //display: inline-block;
              //border-right: #FF9415 1px solid;
              //padding-right: 10px;
              //height: 20px;
            }

            .down + span {
              margin-bottom: -2px;
              margin-right: 10px;
              width: 2px;
              height: 15px;
              background: #dc727c;
              display: inline-block;
            }
          }

          .read {
            margin-top: 10px;
            width: 100%;
            .key {
              word-break: break-all;
              font-size: 14px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #666666;
              margin-right: 25px;
            }
          }
        }
      }
    }
  }

  .classify {
    display: flex;
    height: 30px;
    justify-content: space-between;
    width: 100%;

    .right {
      height: 30px;
      // width: 50%;

      .time {
        //background: yellow;
        line-height: 30px;
        margin-right: 10px;
      }

      .searchinput {
        width: 351px;
        //height: 41px;
        border-radius: 10px;
        margin-left: 33px;
      }
    }

    .left {
      font-size: 14px;
      font-weight: 400;
      color: #333333;
      line-height: 30px;
      cursor: pointer;

      .status {
        margin-right: 3px;
      }

      .statusList {
        margin-left: 10px;
        margin-right: 10px;
      }

      .act {
        margin-left: 10px;
        margin-right: 10px;
        color: #0101f3;
      }
    }
  }
}
::v-deep .ivu-drawer-close {
  top: 0;
  right: 0;
  left: 0;
  width: 36px;
  height: 36px;
  border-radius: 0 0 36px 0;
  background-color: rgba(55,55,55,.6);
  .ivu-icon-ios-close {
    top: -2px;
    left: -2px;
    font-size: 34px;
    color: #fff;
  }
}
</style>
